import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "file-uploader field__widget" }
const _hoisted_2 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_3 = ["disabled", "accept"]
const _hoisted_4 = ["value"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Uploader ")
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      type: "file",
      hidden: "true",
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.uploadFile && _ctx.uploadFile(...args))),
      ref: "fileInput",
      disabled: _ctx.isUploading,
      accept: _ctx.accept
    }, null, 40, _hoisted_3),
    _createElementVNode("input", {
      type: "text",
      disabled: "true",
      value: _ctx.file && _ctx.file.filename ? _ctx.file.filename : _ctx.title
    }, null, 8, _hoisted_4),
    _createElementVNode("button", {
      class: "btn btn-primary",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openFileUploadModal && _ctx.openFileUploadModal(...args))),
      type: "button"
    }, [
      (!_ctx.isUploading)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_5
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(_ctx.progress), 1)
          ], 64))
    ]),
    (_ctx.isImg && _ctx.file)
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: _ctx.file.link,
          alt: "Uploaded file",
          class: "uploaded-file"
        }, null, 8, _hoisted_6))
      : _createCommentVNode("", true)
  ]))
}